export default __webpack_public_path__ + "images/poppy-ship-inactive.svg";